<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Senarai Inbois Deposit">
            <w-form ref="dform" @validate="search">
                
            <w-flex justify-center align-center>
                  <div class="xs6 mr3">
                      <z-input 
                          label="No. Akun Cagaran" 
                          v-model="form.no_akun_cagaran" 
                          name="noAkunCagaran" 
                          placeholder="Sila Masukan No. Akun Cagaran"
                      />
                  </div>
                  <div class="xs6">
                      <z-input 
                          label="No. Fail" 
                          v-model="form.no_fail" 
                          name="noFail"
                          placeholder="Sila Masukan No. Fail"  
                      />
                  </div>
                  
            </w-flex>

            <w-flex class="mt3">
                  <div class="xs4 mr3">
                      <z-input 
                          label="No. Rujukan" 
                          v-model="form.no_rujukan" 
                          name="noRujukan" 
                          placeholder="Sila Masukan No. Rujukan" 
                      />
                  </div>
                  <div class="xs4 mr3">
                      <z-input 
                          label="Profil" 
                          v-model="form.profil" 
                          name="profil"  
                          placeholder="Sila Masukan Profil" 
                      />
                  </div>
                  <div class="xs4">
                      <z-input 
                          label="Status" 
                          v-model="form.set" 
                          name="status" 
                          placeholder="Sila Masukan Status"  
                      />
                  </div>
            </w-flex>


            </w-form>

            <w-flex class="mt1 mb3" wrap align-center justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1 " @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>&nbsp;
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>

            <z-table ref="tbluser" title="Senarai Carta Akaun Akruan" :headers="table.headers" :items="table.items" :meta="table.meta" class="white--bg">
                <template #button>
                    
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        <!-- <w-icon>fal fa-pencil</w-icon> -->
                        Tindakan
                    </template>
                </template>
                <!-- <template #item-cell.penyeleggaraan="{ item, label, header, index }">
                    <w-icon md class="mr1" >{{ item }}</w-icon> 
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                            <w-icon  @click="add(item)">fal fa-plus</w-icon>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                    </w-flex>
                </template> -->
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: 'utiliti.caa',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Utiliti', route: '/utiliti' },
            { label: 'Carta Akaun Akruan ', route: '/utiliti/caa' }
          ],
          form: {
            // id: 0,
            no: '',
            jenis_akaun: '',
            kod_caa: '',
            keterangan_caa: '',
            caa: '',
            sub: '',
            caa_akhir: '',
            },
        }
  },
  methods: {
     add(item) {
            this.dialog.show = true;
            this.form.induk_kod_caa = item.kod_caa;
            this.form.induk = item.keterangan_caa;
            // this.clearItem();
        },

       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 600
    this.dialog.height = 150
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>